export const TEMPLATE_TYPE = "PLANILLA_FINAL_VIDA_LEY";

export const COD_APPLICATION = "2";

export const TEMPLATE_FILE_UPLOAD = "PLANILLA_TMP_VIDA_LEY";
